<template>
    <transition name="fade">
        <div v-show="show"
             class="popup-overlay"
             :id="overlayId"
             @click="hide">
            <div class="popup-frame"
                 :style="{width: frameWidth + 'px',
                            height: frameHeight + 'px',
                            fontSize: FontSizes.small1,
                            left: posX + 'px',
                            top: posY + 'px'}">
                <div v-for="item in items"
                     :key="item.itemId"
                     class="menu-item"
                     @click="onClickItem(item)"
                     :style="{height: itemHeight + 'px',
                                lineHeight: itemHeight + 'px'}">{{item.text}}</div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import {computed, defineComponent, nextTick, PropType, ref, watch} from "vue";
import {FontSizes} from "@/utils/font-sizes";
import {v4 as uuidv4} from "uuid"

export type popupMenuItemType = {
    itemId: string,
    text: string,
    data: any,
    cb: (itemId: string, data: any) => void
}

export type popupPositionType = {
    x: number,
    y: number
}

export default defineComponent({
    name: "PopupMenu",
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        hide: {
            type: Function as PropType<() => void>,
            required: true,
        },
        items: {
            type: Array as PropType<popupMenuItemType[]>,
            required: true
        },
        position: {
            type: Object as PropType<popupPositionType>,
            required: true,
        },
    },
    setup(props) {

        const itemHeight = 30,
                textWidth = 15,
                frameHeight = ref<number>(itemHeight),
                frameWidth = ref<number>(200),
                posX = ref<number>(0),
                posY = ref<number>(0),
                overlayId = ref<string>(`popup-overlay-${uuidv4()}`)

        const calcHeight = (): number => {
            return itemHeight * props.items.length
        }

        const updateSize = () => {
            frameHeight.value = itemHeight * props.items.length

            let maxTextLength = 0
            props.items.forEach(item => {
                if (item.text.length > maxTextLength) {
                    maxTextLength = item.text.length
                }
            })

            maxTextLength += 2
            frameWidth.value = textWidth * maxTextLength
        }

        const updatePosition = () => {

            const overlayDiv = document.getElementById(overlayId.value) as HTMLDivElement
            if (overlayDiv) {
                const overlayRect = overlayDiv.getBoundingClientRect()
                // console.log(overlayRect)

                posX.value = props.position.x
                posY.value = props.position.y - overlayRect.y

                if (posX.value + frameWidth.value > overlayRect.width) {
                    posX.value = overlayRect.width - frameWidth.value - 5
                }

                // console.log(window.innerHeight)

                // if (posY.value + frameHeight.value > window.innerHeight + window.scrollY) {
                //     posY.value = window.innerHeight + window.scrollY - frameHeight.value - 5
                // }

                // if (posY.value + frameHeight.value > overlayRect.height - overlayRect.y) {
                //     posY.value = overlayRect.height - frameHeight.value - 5 - overlayRect.y
                // }
            }
        }

        watch(() => props.show, () => {
            if (props.show) {
                nextTick(() => {
                    updateSize()
                    updatePosition()
                })
            }
        })

        const onClickItem = (item: popupMenuItemType) => {
            item.cb(item.itemId, item.data)
            props.hide()
        }

        return {
            FontSizes,
            calcHeight,
            itemHeight,
            frameHeight,
            frameWidth,
            posX,
            posY,
            overlayId,
            onClickItem,
        }
    }
})
</script>

<style scoped lang="scss">

.fade-enter-active,
.fade-leave-active {
    /* 表示されている際のCSSはこのブロックに記述 */
    transition: opacity .3s;
}

.fade-enter-from,
.fade-leave-to {
    /* 非表示の際のCSSはこのブロックに記述 */
    opacity: 0;
}

.popup-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    //background-color: red;

    .popup-frame {
        position: absolute;
        background-color: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(5px);
        box-shadow: 1px 1px 3px rgba(100, 100, 100, 0.3);

        .menu-item {
            &:hover {
                opacity: 0.7;
            }

            &:active {
                opacity: 0.5;
            }
        }
    }
}


</style>